export default "__VITE_ASSET__Bnif$Ggv__"